var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#0078D4;}\n\t.st2{fill:url(#SVGID_00000031178533246841963090000018201972349987581877_);}\n\t.st3{fill:url(#SVGID_00000007423927393109958100000008996277696075285662_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1154.0826,
    y1: 547.5646,
    x2: -1165.3893,
    y2: 580.9675,
    gradientTransform: "matrix(1.5625 0 0 1.5625 1829.875 -848.6406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#114A8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0669BC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,2.9h17L19.8,55.2c-0.4,1.1-1.4,1.8-2.6,1.8H4c-1.5,0-2.7-1.2-2.7-2.7c0-0.3,0-0.6,0.1-0.9L17.9,4.8 C18.2,3.7,19.3,2.9,20.4,2.9L20.4,2.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.1,38h-27c-0.7,0-1.2,0.6-1.2,1.2c0,0.3,0.1,0.7,0.4,0.9l17.3,16.2c0.5,0.5,1.2,0.7,1.9,0.7h15.3L45.1,38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096051985796155447340000014875797132332998799_",
    gradientUnits: "userSpaceOnUse",
    x1: -1150.5507,
    y1: 563.1307,
    x2: -1153.1661,
    y2: 564.0151,
    gradientTransform: "matrix(1.5625 0 0 1.5625 1829.875 -848.6406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096051985796155447340000014875797132332998799_)"
    },
    d: "M20.4,2.9c-1.2,0-2.2,0.8-2.6,1.9L1.4,53.5 c-0.5,1.4,0.2,3,1.6,3.5C3.3,57,3.7,57.1,4,57.1h13.6c1-0.2,1.9-0.9,2.2-1.9l3.3-9.7l11.7,10.9c0.5,0.4,1.1,0.6,1.7,0.6h15.2L45,38 l-19.5,0L37.5,2.9H20.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092445202090763595130000009972651213007038901_",
    gradientUnits: "userSpaceOnUse",
    x1: -1151.9077,
    y1: 546.5599,
    x2: -1139.4962,
    y2: 579.6262,
    gradientTransform: "matrix(1.5625 0 0 1.5625 1829.875 -848.6406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3CCBF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2892DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092445202090763595130000009972651213007038901_)"
    },
    d: "M42.1,4.8c-0.4-1.1-1.4-1.8-2.6-1.8h-19 c1.2,0,2.2,0.7,2.6,1.8l16.5,48.8c0.5,1.4-0.3,3-1.7,3.4c-0.3,0.1-0.6,0.1-0.9,0.1h19c1.5,0,2.7-1.2,2.7-2.7c0-0.3,0-0.6-0.1-0.9 L42.1,4.8z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftAzure);
export default __webpack_public_path__ + "static/media/Microsoft_Azure.f63332f44b9ee00b04c5c3f21f43cd26.svg";
export { ForwardRef as ReactComponent };